const resendRecommendationEmail = async ({
  id,
  products,
  token,
  successCallback,
  errorCallback,
  sendCC,
}) =>
  fetch("/api/resend-email", {
    method: "POST",
    body: JSON.stringify({ id, products, token, sendCC }),
  })
    .then(res => res.json())
    .then(res => {
      console.log(res, "response");
      if (res?.success) successCallback(res);
      if (res?.error) {
        if (errorCallback)
          errorCallback(
            "Something went wrong. Please try again or contact Kan Herb Company Staff."
          );
        // eslint-disable-next-line no-console
        console.log(res?.error);
        return res;
      }
      return res;
    })
    .catch(e => {
      if (errorCallback) errorCallback(e);
      // eslint-disable-next-line no-console
      console.log(e);
    });

export default resendRecommendationEmail;
